// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#admin-table-pagination[data-v-5dfd16b8]{display:flex;flex-flow:row;justify-content:center;align-items:center}#pagination[data-v-5dfd16b8]{flex:0 1 auto!important}.pagination-footer[data-v-5dfd16b8]{height:65px!important;margin-left:55px}#pagination button[data-v-5dfd16b8],#pagination ul[data-v-5dfd16b8],.pagination-footer[data-v-5dfd16b8]{background-color:#fafafa!important}", ""]);
// Exports
module.exports = exports;
